import { render, staticRenderFns } from "./ssoLogin.vue?vue&type=template&id=51b1cc40&scoped=true"
import script from "./ssoLogin.vue?vue&type=script&lang=js"
export * from "./ssoLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b1cc40",
  null
  
)

export default component.exports